/* eslint-disable no-undef */
export default {
  LOGS: process.env.LOGS,
  API_URL: process.env.API_URL,
  REDIRECT_URL: process.env.REDIRECT_URL || 'http://dev.cat.tectonic.it/',
  ENV: process.env.ENV,
  sessionExpirationTime: process.env.SESSION_EXPIRATION || 15 * 60 * 1000,
  sessionExpirationPopupTime: process.env.SESSION_EXPIRATION_POPUP || 10 * 1000
}



// WEBPACK FOOTER //
// ./src/config.js